import React, { useEffect, useState } from 'react';
import { ParamsNotFoundError } from '../../../helpers/definedErrors';
import { Text, Card, CloseButton, Button } from '@smarterservices/smarter-ui';

import { removeIframe, sendMessageToExtension } from '../../../helpers/helpers';
const Confirmation = () => {
  const [bodyText, setBodyText] = useState(null);
  const [iframeId, setIframeId] = useState(null);
  const [confirmationFunctionName, setConfirmationFunctionName] =
    useState(null);

  useEffect(() => {
    // Get the URL params to get the body text and the iframeId
    const url = new URL(window.location.href);
    const confirmationParams = new Proxy(new URLSearchParams(url.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });

    if (
      !confirmationParams ||
      !confirmationParams.bodyText ||
      !confirmationParams.iframeId ||
      !confirmationParams.confirmationFunctionName
    ) {
      throw new ParamsNotFoundError();
    }

    setBodyText(confirmationParams.bodyText);
    setIframeId(confirmationParams.iframeId);
    setConfirmationFunctionName(confirmationParams.confirmationFunctionName);
  }, []);

  async function closeConfirmation() {
    const response = await removeIframe(iframeId);
    if (!response) {
      console.log(
        'Extension was removed and popup remains. Reload page to remove.'
      );
    }
  }

  async function confirm() {
    const response = await sendMessageToExtension({
      message: 'sp_background__runConfirmation',
      confirmationFunctionName,
      iframeId,
    });

    if (!response) {
      console.log('No response from confirmation function.');
    }
  }

  return (
    <>
      {bodyText && iframeId && confirmationFunctionName && (
        <Card
          background="secondary"
          borderColor="brand"
          borderWidth="large"
          borderRadius="x-small"
        >
          <Card.Header background="brand">
            <Card.Title>Confirmation</Card.Title>
            <Card.Actions>
              <CloseButton
                color="primary-inverse"
                screenReaderLabel="Close"
                onClick={closeConfirmation}
              />
            </Card.Actions>
          </Card.Header>
          <Card.Body padding="0" height="100%">
            <div
              style={{
                position: 'relative',
                height: '100%',
                width: '100%',
                overflow: 'hidden',
              }}
            >
              {/* Scrollable text area */}
              <div
                style={{
                  width: '100%',
                  maxHeight: 'calc(100% - 100px)',
                  padding: '48px 32px',
                  overflow: 'auto',
                  textAlign: 'center',
                }}
              >
                <Text size="medium" align="center">
                  {bodyText}
                </Text>
              </div>

              {/* Fixed button container */}
              <div
                style={{
                  position: 'absolute',
                  bottom: '0',
                  left: '0',
                  right: '0',
                  height: '100px',
                  padding: '0px 32px',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'start',
                }}
              >
                <Button color="primary" onClick={confirm}>
                  Confirm
                </Button>
              </div>
            </div>
          </Card.Body>
        </Card>
      )}
    </>
  );
};

export default Confirmation;
